import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import Translation from '@s/Translation';

class AddedToCartMessage extends Component {

    transitionToCart = () => {
        this.props.triggerTransition("cart", {token: this.props.token});
    }

    render() {
        return( 
            <div className="message message__inline-banner message--success">
                <div className="message__icon">
                    <i className="icon-check" aria-hidden="true" />
                </div>
                <div className="message__text message__text--align-left">
                    <Translation interpolation={{countCartedItems:this.props.countCartedItems}}>{"checkout__added_to_cart"}</Translation>
                </div>
                {!!this.props.canEdit && <div className="message__action">
                    <a onClick={this.transitionToCart}>
                        <i className="icon-mode_edit" aria-hidden="true" /> <Translation>{"checkout__edit"}</Translation>
                    </a>
                </div>}
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        token: state.reservation.token,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        triggerTransition,
    }, dispatch);
}

AddedToCartMessage.propTypes = {
    countCartedItems: PropTypes.number,
    canEdit: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddedToCartMessage);
